<template>
  <div
    class="AiMap"
    role="complementary"
    :aria-label="$t('accessibility.description.hotelLocationMap')">
    <div ref="mapRef" class="AiMap-map" />
  </div>
</template>
<script lang="ts" setup>
import { Loader } from '@googlemaps/js-api-loader';

import { MapStyle } from './types';

import MapMarker from '~~/assets/svg/map-marker.svg';
import MapMarker2 from '~~/assets/svg/map-marker-2.svg';

export interface Position {
  lat: number;
  lng: number;
}

export interface AiMapProps {
  center: Position;
  hotelPosition: Position;
  firstRing: Position;
  secondRing: Position;
  zoom?: number;
}

const props = withDefaults(defineProps<AiMapProps>(), {
  zoom: 15,
});

const mapRef = ref();

const {
  public: { googleApiKey },
} = useRuntimeConfig();

const gmap = ref<google.maps.Map>();
const markers = ref<google.maps.Marker[]>([]);

onMounted(async () => {
  const loader = new Loader({ apiKey: googleApiKey });

  await loader.load();

  gmap.value = new google.maps.Map(mapRef.value, {
    center: props.center,
    styles: MapStyle,
    zoom: props.zoom,
    disableDefaultUI: true,
    gestureHandling: 'none',
  });

  markers.value = [
    new google.maps.Marker({
      position: props.hotelPosition,
      map: gmap.value,
      icon: {
        url: MapMarker,
        scaledSize: new google.maps.Size(30, 30),
      },
    }),
    new google.maps.Marker({
      position: props.firstRing,
      map: gmap.value,
      icon: {
        url: MapMarker2,
        scaledSize: new google.maps.Size(400, 400),
      },
    }),
    new google.maps.Marker({
      position: props.secondRing,
      map: gmap.value,
      icon: {
        url: MapMarker2,
        scaledSize: new google.maps.Size(900, 900),
      },
    }),
  ];
});

onBeforeUnmount(() => {
  if (markers.value.length > 0) {
    for (const marker of markers.value) {
      marker.unbindAll();
    }
  }

  if (gmap.value) {
    gmap.value.unbindAll();
  }
});
</script>
<style scoped lang="scss">
.AiMap {
  width: 100%;
  height: 100%;
}

.AiMap-map {
  width: 100%;
  height: 100%;
}

.AiMap-frame {
  height: 100%;
}
</style>
